import React, { Suspense } from 'react';

// --- EAGERLY IMPORT CRITICAL COMPONENTS ---
// These are needed immediately for the initial view.
import Header from './components/Header';
import Hero from './components/Hero';

// Conditionally import the background you are using
import MatrixBackground from './components/MatrixBackground'; 
// import ParticleBackground from './components/ParticleBackground'; 

// --- LAZY-LOAD NON-CRITICAL, "BELOW-THE-FOLD" COMPONENTS ---
const About = React.lazy(() => import('./components/About'));
const Skills = React.lazy(() => import('./components/Skills'));
const Projects = React.lazy(() => import('./components/Projects'));
const Experience = React.lazy(() => import('./components/Experience'));
const Testimonials = React.lazy(() => import('./components/Testimonials'));
const Blog = React.lazy(() => import('./components/Blog'));
const Volunteer = React.lazy(() => import('./components/Volunteer'));
const Contact = React.lazy(() => import('./components/Contact'));

// A fallback for sections as they load on scroll
const LoadingFallback = () => <div style={{ height: '100vh' }}></div>;

function App() {
  return (
    <div className="App">
      <MatrixBackground /> {/* Or your chosen background */}
      
      {/* Render critical components immediately */}
      <Header />
      <main>
        <Hero />
        
        {/* Wrap only the lazy components in a Suspense boundary */}
        <Suspense fallback={<LoadingFallback />}>
          <About />
          <Skills />
          <Projects />
          <Experience />
          <Testimonials />
          <Blog />
          <Volunteer />
        </Suspense>
      </main>

      {/* The Contact/Footer can also be lazy-loaded */}
      <Suspense fallback={null}>
        <Contact />
      </Suspense>
    </div>
  );
}

export default App;